"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Prezzario() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const tiers = [{
    name: "Starter",
    price: "€99",
    features: ["1 video social al mese", "Durata fino a 30 secondi", "Revisione inclusa"]
  }, {
    name: "Business",
    price: "€249",
    features: ["3 video social al mese", "Durata fino a 60 secondi", "2 revisioni incluse"]
  }, {
    name: "Premium",
    price: "€499",
    features: ["6 video social al mese", "Durata illimitata", "Revisioni illimitate"]
  }];
  return <section className="relative py-24 bg-dark-background text-foreground-dark overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-accent/10 pointer-events-none" />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display font-bold mb-4 bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent">
            Prezzi Trasparenti
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Scegli il piano perfetto per le tue esigenze di video marketing
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <div ref={ref1} data-index={0} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-scroll)] ${isVisible1 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: "0ms"
        }}>
            <Card className="h-full bg-gradient-to-br from-muted-dark-background/80 to-muted-dark-background/40 border border-muted/20 shadow-strong hover:-translate-y-1.5 hover:shadow-[0_12px_40px_rgba(0,0,0,0.24),0_6px_16px_rgba(0,0,0,0.12),0_0_0_1px_hsla(35,90%,50%,0.3)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] backdrop-blur-sm">
              <CardHeader>
                <CardTitle className="text-2xl font-display text-foreground-dark">
                  {tiers[0].name}
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-6">
                <div>
                  <span className="text-5xl font-bold text-primary font-display">{tiers[0].price}</span>
                  <span className="text-muted-foreground ml-2">/mese</span>
                </div>
                <ul className="space-y-3">
                  {tiers[0].features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                      <Check className="size-5 text-secondary shrink-0 mt-0.5" />
                      <span className="text-foreground-dark">{feature}</span>
                    </li>)}
                </ul>
                <Button asChild className="w-full bg-primary hover:bg-primary-hover active:bg-primary-active hover:scale-[1.03] active:scale-[0.97] transition-transform duration-[var(--duration-fast)] ease-out shadow-medium">
                  <Link to="/ContactPage">
                    Inizia Ora
                  </Link>
                </Button>
              </CardContent>
            </Card>
          </div>

          <div ref={ref2} data-index={1} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-scroll)] ${isVisible2 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: "100ms"
        }}>
            <Card className="h-full bg-gradient-to-br from-muted-dark-background/80 to-muted-dark-background/40 border border-accent/40 shadow-strong hover:-translate-y-1.5 hover:shadow-[0_12px_40px_rgba(0,0,0,0.24),0_6px_16px_rgba(0,0,0,0.12),0_0_0_1px_hsla(270,90%,55%,0.4)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] backdrop-blur-sm ring-2 ring-accent/20">
              <CardHeader>
                <CardTitle className="text-2xl font-display text-foreground-dark flex items-center gap-2">
                  {tiers[1].name}
                  <span className="text-xs px-2 py-1 bg-accent/20 text-accent rounded-full">Popolare</span>
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-6">
                <div>
                  <span className="text-5xl font-bold text-accent font-display">{tiers[1].price}</span>
                  <span className="text-muted-foreground ml-2">/mese</span>
                </div>
                <ul className="space-y-3">
                  {tiers[1].features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                      <Check className="size-5 text-secondary shrink-0 mt-0.5" />
                      <span className="text-foreground-dark">{feature}</span>
                    </li>)}
                </ul>
                <Button asChild className="w-full bg-accent hover:bg-accent-hover active:bg-accent-active hover:scale-[1.03] active:scale-[0.97] transition-transform duration-[var(--duration-fast)] ease-out shadow-medium">
                  <Link to="/ContactPage">
                    Inizia Ora
                  </Link>
                </Button>
              </CardContent>
            </Card>
          </div>

          <div ref={ref3} data-index={2} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-scroll)] ${isVisible3 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: "200ms"
        }}>
            <Card className="h-full bg-gradient-to-br from-muted-dark-background/80 to-muted-dark-background/40 border border-muted/20 shadow-strong hover:-translate-y-1.5 hover:shadow-[0_12px_40px_rgba(0,0,0,0.24),0_6px_16px_rgba(0,0,0,0.12),0_0_0_1px_hsla(175,80%,48%,0.3)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] backdrop-blur-sm">
              <CardHeader>
                <CardTitle className="text-2xl font-display text-foreground-dark">
                  {tiers[2].name}
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-6">
                <div>
                  <span className="text-5xl font-bold text-secondary font-display">{tiers[2].price}</span>
                  <span className="text-muted-foreground ml-2">/mese</span>
                </div>
                <ul className="space-y-3">
                  {tiers[2].features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                      <Check className="size-5 text-secondary shrink-0 mt-0.5" />
                      <span className="text-foreground-dark">{feature}</span>
                    </li>)}
                </ul>
                <Button asChild className="w-full bg-secondary hover:bg-secondary-hover active:bg-secondary-active hover:scale-[1.03] active:scale-[0.97] transition-transform duration-[var(--duration-fast)] ease-out shadow-medium">
                  <Link to="/ContactPage">
                    Inizia Ora
                  </Link>
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}